<template>
  <div @mouseenter="hovering=true"
       @mouseleave="hovering=false">
    <MasonryAssetView class="tw-text-white tw-group tw-min-h-[180px] tw-rounded-lg"
                      imageClass="tw-rounded-lg"
                      :asset-url="assetPublicUrl(asset)"
                      :image-url="asset.watermark_medium_url">

      <video-hover-player v-if="asset.type === 'Video'"
                          :asset-id="asset.objectID"
                          :play="hovering"
                          class="tw-rounded-lg"
                          :disable-internal-hover="true"
                          :thumb="asset.watermark_medium_url"
                          :video="assetVideoUrl"/>

      <template #top-right>
        <AssetCardTop :asset="asset" :user-slug="userSlug"/>
      </template>

      <template #bottom-left>
        <AssetCardBottom :asset="asset"
                         @preview="$emit('preview', asset)"
                         :projectsUrl="projectsUrl"
                         :projectAssetsUrl="projectAssetsUrl"/>
      </template>
    </MasonryAssetView>
  </div>
</template>
<script>

import AddToProject from "../Customers/Dashboard/AddToProject.vue";
import GeneralMixins from "../../mixins/GeneralMixins";
import MasonryAssetView from "../Search/MasonryAssetView.vue";
import AssetCardTop from "./AssetCardTop.vue";
import AssetCardBottom from "./AssetCardBottom.vue";

export default {
  mixins: [GeneralMixins],

  data() {
    return {
      hovering: false
    }
  },

  props: [
    'asset',
    'userSlug',
    'projectsUrl',
    'projectAssetsUrl'
  ],

  computed: {
    assetVideoUrl() {
      return this.asset.video_url;
    },

    isVideo() {
      return this.currentType === "Video"
    },
  },

  components: {AssetCardBottom, AssetCardTop, MasonryAssetView, AddToProject}
}
</script>